import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/DonationWidget.css'; // Assurez-vous d'importer le fichier CSS
import handshake from '../assets/handshake.png';

const DonationWidget = () => {
    useEffect(() => {
        const handleHover = () => {
            if (window.innerWidth > 768) {
                document.querySelector('.donation-icon').style.opacity = '0';
                document.querySelector('.donation-text').style.display = 'block';
            }
        };

        const handleMouseLeave = () => {
            if (window.innerWidth > 768) {
                document.querySelector('.donation-icon').style.opacity = '1';
                document.querySelector('.donation-text').style.display = 'none';
            }
        };

        const donationButton = document.querySelector('.donation-button');
        donationButton.addEventListener('mouseenter', handleHover);
        donationButton.addEventListener('mouseleave', handleMouseLeave);

        // Reset styles when returning from donation page
        const handleFocus = () => {
            handleMouseLeave();
        };

        window.addEventListener('focus', handleFocus);

        // Cleanup event listeners on component unmount
        return () => {
            donationButton.removeEventListener('mouseenter', handleHover);
            donationButton.removeEventListener('mouseleave', handleMouseLeave);
            window.removeEventListener('focus', handleFocus);
        };
    }, []);

    return (
        <div className="donation-widget">
            <Link to="/pages/FaireUnDon"  target="_blank" className="donation-button">
                <img src={handshake} alt="Euro" className="donation-icon" />
                <span className="donation-text">Faire un don</span>
            </Link>
        </div>
    );
};

export default DonationWidget;
